module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    ref: "slider",
    staticClass: "col-xs-12 col-sm-12 col-lg-10 col-lg-offset-1 carousel"
  }, [_c('div', {
    staticClass: "carousel-inner",
    on: {
      "touchstart": _vm.startSwipe,
      "touchmove": _vm.moveSwipe,
      "touchend": _vm.endSwipe
    }
  }, _vm._l((_vm.myCaseStudies), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.position >= -2 && item.position < 3),
        expression: "item.position >= -2 && item.position < 3"
      }],
      key: index,
      staticClass: "carousel-container",
      class: {
        'carousel-quick': item.position >= 2 && _vm.blockRight || item.position <= -2 && _vm.blockLeft
      },
      style: ({
        '-webkit-transition-delay': 'webkit-transform ' + (item.position * 0.05) + 's',
        'webkit-transform': 'translateX(' + item.position * _vm.gap + '%)'
      })
    }, [_c('div', {
      staticClass: "carousel-template",
      class: 'carousel-template-' + item.t
    }, [_c('div', {
      staticClass: "carousel-img carousel-img1"
    }, [_c('image-loader', {
      staticClass: "image-loader-container",
      attrs: {
        "imgSrc": 'carousel/' + item.img1
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-img-overlay",
      class: {
        'active': item.position !== 0
      }
    })], 1), _vm._v(" "), (item.img2) ? _c('div', {
      staticClass: "carousel-img carousel-img2"
    }, [_c('image-loader', {
      staticClass: "image-loader-container",
      attrs: {
        "imgSrc": 'carousel/' + item.img2
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-img-overlay",
      class: {
        'active': item.position !== 0
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.img3) ? _c('div', {
      staticClass: "carousel-img carousel-img3"
    }, [_c('image-loader', {
      staticClass: "image-loader-container",
      attrs: {
        "imgSrc": 'carousel/' + item.img3
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-img-overlay",
      class: {
        'active': item.position !== 0
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('label', {
      class: {
        'active': item.position == 0
      },
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "arrow-button arrow-left",
    on: {
      "click": function($event) {
        _vm.clickArrow(1)
      }
    }
  }, [_c('img', {
    staticClass: "arrow-button-svg arrow-button-svg-dark",
    attrs: {
      "src": 'static/img/common/left_dark.svg'
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "arrow-button-svg arrow-button-svg-light",
    attrs: {
      "src": 'static/img/common/left_light.svg'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "arrow-button arrow-right",
    on: {
      "click": function($event) {
        _vm.clickArrow(-1)
      }
    }
  }, [_c('img', {
    staticClass: "arrow-button-svg arrow-button-svg-dark",
    attrs: {
      "src": 'static/img/common/left_dark.svg'
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "arrow-button-svg arrow-button-svg-light",
    attrs: {
      "src": 'static/img/common/left_light.svg'
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30eaf46c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyCarousel.vue
// module id = 140
// module chunks = 2